module.exports = {"513227100":"美兴镇","513227101":"四姑娘山镇","513227102":"两河口镇","513227103":"达维镇","513227200":"老营乡","513227201":"崇德乡","513227202":"新桥乡","513227203":"美沃乡","513227204":"沙龙乡","513227205":"宅垄乡","513227206":"新格乡","513227208":"日尔乡","513227209":"结斯乡","513227210":"沃日乡","513227211":"木坡乡","513227213":"抚边乡","513227214":"八角乡","513227215":"双柏乡","513227216":"窝底乡","513227217":"汗牛乡","513227218":"潘安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513227.json
// module id = 2219
// module chunks = 0